document.addEventListener("DOMContentLoaded", function () {
    const varIdsToRemove = [45226049339554, 45226049306786, 45261467943074, 45261467975842]; 
    fetch('/cart.js')
      .then(response => response.json())
      .then(cart => {
        cart.items.forEach(item => {
          if (varIdsToRemove.includes(item.variant_id)) {
            fetch('/cart/change.js', {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json'
              },
              body: JSON.stringify({
                id: item.key,
                quantity: 0
              })
            }).then(response => {
              if (response.ok) {
                console.log('Variant removed');
              } else {
                console.error('Failed to remove item', item.variant_id);
              }
            });
          }
        });
      })
      .catch(error => console.error('Error fetching cart:', error));
});